import { useAppConfigContext } from '@/context/AppConfig';
import { Box, Button, Card, Pill, Stack, Text, styled } from '@/theme/index';
import { DateUtil } from '@/utils/index';
import { GroupedNotificationValue } from '../types';

export const TextWithIcon = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  svg: {
    marginRight: theme.spacing(1),
  },
}));

export const CornerTag = styled(Pill)(({ theme }) => ({
  position: 'absolute',
  right: '-10px',
  top: '-10px',
  fontSize: '0.75rem',
  height: theme.spacing(2),
}));

export function MonitoringNotification({
  notification,
}: {
  notification: GroupedNotificationValue;
}) {
  const dateUtil = new DateUtil();
  const { navigate } = useAppConfigContext().routingUtils;

  function mapReportTypeToRoute(): { [key: string]: string } {
    return {
      social_network_report: 'email',
      vehicle_report: 'vehicle',
      username_report: 'username',
      reverse_phone_report: 'phone',
      detailed_person_report: 'person',
      property_report: 'property',
      contact_report: 'contact',
    };
  }

  function viewReport() {
    const { permalink } = notification;
    const route = `${
      mapReportTypeToRoute()[notification.type || 'detailed_person_report']
    }`;
    navigate(`/report/${route}?permalink=${permalink}`);
  }

  return (
    <Card
      variant="outlined"
      className="hover-shadow"
      sx={{ position: 'relative', overflow: 'visible' }}
    >
      {notification.newInfo && (
        <CornerTag color="info" label="NEW INFO" className="badge" />
      )}
      <Stack direction="row" width="100%">
        <Box width="100%">
          <Stack direction="row" alignItems="center" mb={1}>
            <Text
              variant="h2"
              sx={{ display: 'inline', wordBreak: 'break-all' }}
            >
              New changes identified for{' '}
              <Text color="primary" variant="h2" sx={{ display: 'inline' }}>
                {notification.owner}
              </Text>
            </Text>
          </Stack>
          {notification.changes.map((change) => (
            <Box key={change.data.permalink}>
              <Stack direction="row" alignItems="center" mb={1}>
                {change.count && parseInt(change.count) > 1 && (
                  <Text color="primary" variant="h3">
                    {change.count}
                  </Text>
                )}
                <Text color="primary" variant="h3">
                  &nbsp;{change.message}
                </Text>
              </Stack>
              <Text variant="body2" mb={1}>
                Date {dateUtil.parseDateFromString(change.date, 'LLL dd, yyyy')}
              </Text>
            </Box>
          ))}
        </Box>
        <div>
          <Button
            sx={{ width: ['100%', 'auto'], minWidth: '172px', mb: 2 }}
            variant="contained"
            color="success"
            onClick={() => viewReport()}
          >
            View Report
          </Button>
        </div>
      </Stack>
    </Card>
  );
}
